'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Spinner = require('../spinner/Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

var _Icon = require('../icon/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _IconsStore = require('./IconsStore');

var _IconsStore2 = _interopRequireDefault(_IconsStore);

var _DropDown = require('./DropDown.style');

var _DropDown2 = require('./DropDown.helper');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable react/forbid-prop-types */


var DropDown = function DropDown(_ref) {
  var props = _objectWithoutProperties(_ref, []);

  var fieldLabel = props.fieldLabel,
      searchable = props.searchable,
      multipleSelection = props.multipleSelection,
      options = props.options,
      extendDropDownStyle = props.extendDropDownStyle,
      icon = props.icon,
      iconSize = props.iconSize,
      onChanges = props.onChanges,
      onSearch = props.onSearch,
      isRequired = props.isRequired,
      extendDropDownList = props.extendDropDownList,
      extendDropDownListItem = props.extendDropDownListItem,
      onClickIconAction = props.onClickIconAction,
      componentName = props.componentName,
      isDisabled = props.isDisabled,
      language = props.language,
      isLoading = props.isLoading,
      isValid = props.isValid,
      onResetSearch = props.onResetSearch,
      fieldValue = props.fieldValue;

  var _useState = (0, _react.useState)([]),
      selectedOptions = _useState[0],
      setSelectOption = _useState[1]; // for selected items


  var _useState2 = (0, _react.useState)(''),
      typedValue = _useState2[0],
      setTypedValue = _useState2[1];

  var timer = (0, _react.useRef)(null);

  (0, _react.useEffect)(function () {
    if (!fieldValue) {
      // setTypedValue('');
      setSelectOption([]);
    } else if (fieldValue !== undefined && options && options.length) {
      var filteredOption = options.filter(function (option) {
        return option.value === fieldValue;
      });
      if (filteredOption && filteredOption[0]) {
        setTypedValue(filteredOption[0].fieldValue);
        setSelectOption(filteredOption);
      }
    }
  }, [fieldValue]);

  var toggleDropDowns = function toggleDropDowns() {
    var dropDowns = document.querySelectorAll('div[class^="dropdown"]');
    var anotherDropDownsLabels = [];

    // Get all onther dropdown other than the current clicked one
    dropDowns.forEach(function (dropDown) {
      var dropDownClassName = Array.from(dropDown.classList).filter(function (className) {
        return className.includes('dropdown-');
      });
      if (dropDownClassName[0] !== 'dropdown-' + componentName) {
        anotherDropDownsLabels.push(dropDownClassName[0]);
      }
    });

    // Close opened lists of all onther dropdowns
    anotherDropDownsLabels.forEach(function (dropDown) {
      var label = dropDown.split('-')[1];
      var list = document.getElementById('dropdown-list-' + label);
      if (list) list.style.display = 'none';
    });
  };

  var onItemSelect = function onItemSelect(option) {
    if (searchable) setTypedValue(option.fieldValue);
    setSelectOption([option]);
    if (onChanges) {
      onChanges(option);
    }
    (0, _DropDown2.dropDownListToggler)(options, 'dropdown-list-' + componentName);
  };

  var onSearchInList = function onSearchInList(value) {
    setTypedValue(value);
    var list = document.getElementById('dropdown-list-' + componentName);
    if (list && list.style.display === 'none') {
      list.style.display = 'block';
    }

    clearTimeout(timer.current);
    if (onSearch && value && value.length > 0) {
      timer.current = setTimeout(function () {
        onSearch(value);
      }, 500);
    } else if (onResetSearch) onResetSearch();
  };

  var isFieldValueRendered = !searchable && selectedOptions.length > 0;
  var isInputFieldRendered = searchable;

  var onFieldClick = function onFieldClick() {
    if (searchable) {
      if (document.getElementById('input-container-' + componentName)) {
        document.getElementById('input-container-' + componentName).focus();
      }
    }
    toggleDropDowns();
    (0, _DropDown2.dropDownListToggler)(options, 'dropdown-list-' + componentName);
  };

  return _react2.default.createElement(
    'div',
    { style: { position: 'relative' }, className: 'dropdown dropdown-' + componentName },
    _react2.default.createElement(_DropDown.DisableOverLay, { isDisabled: isDisabled }),
    _react2.default.createElement(
      _DropDown.FieldContainer,
      { isValid: isValid, isDimmed: false, extendDropDownStyle: extendDropDownStyle },
      _react2.default.createElement(
        _DropDown.LabelValueContainer,
        {
          style: { width: '90%' },
          onClick: function onClick() {
            if (options && options.length || searchable) onFieldClick();
          }
        },
        fieldLabel && _react2.default.createElement(
          _DropDown.FieldLabel,
          { isValueSelected: searchable || selectedOptions.length },
          fieldLabel,
          isRequired && _react2.default.createElement(
            _DropDown.IsRequiredNote,
            null,
            '*'
          )
        ),
        isFieldValueRendered && _react2.default.createElement(
          _DropDown.FieldValue,
          null,
          (0, _DropDown2.renderSelectedOptions)(selectedOptions, multipleSelection)
        ),
        isInputFieldRendered && _react2.default.createElement(_DropDown.SearchInput, {
          autoComplete: 'off',
          id: 'input-container-' + componentName,
          type: 'text',
          value: typedValue,
          onChange: function onChange(e) {
            onSearchInList(e.target.value);
          }
        })
      ),
      icon && _react2.default.createElement(
        'div',
        { style: { display: 'inline-flex', alignItems: 'center' } },
        isLoading ? _react2.default.createElement(_Spinner2.default, { radius: 20, color: '#58595b' }) : _react2.default.createElement(_Icon2.default, {
          className: 'icon',
          onClick: function onClick() {
            if (onClickIconAction) {
              onClickIconAction();
            } else {
              onFieldClick();
            }
          },
          icon: _IconsStore2.default.getIcon(icon),
          width: iconSize
        })
      ),
      !icon && _react2.default.createElement(
        'div',
        { style: { display: 'inline-flex', alignItems: 'center' } },
        isLoading ? _react2.default.createElement(_Spinner2.default, { radius: 20, color: '#58595b' }) : ''
      )
    ),
    _react2.default.createElement(
      'div',
      { id: 'dropdown-list-' + componentName, style: { display: 'none', position: 'relative' } },
      _react2.default.createElement(
        _DropDown.ListContainer,
        { extendDropDownList: extendDropDownList },
        (0, _DropDown2.renderDropDownList)(options, multipleSelection, onItemSelect, {
          extendDropDownListItem: extendDropDownListItem
        }, componentName, language)
      )
    )
  );
};

DropDown.propTypes = process.env.NODE_ENV !== "production" ? {
  fieldValue: _propTypes2.default.string,
  fieldLabel: _propTypes2.default.string.isRequired,
  icon: _propTypes2.default.string.isRequired,
  searchable: _propTypes2.default.bool,
  selectFirst: _propTypes2.default.bool,
  multipleSelection: _propTypes2.default.bool,
  options: _propTypes2.default.array,
  onChanges: _propTypes2.default.func.isRequired,
  iconSize: _propTypes2.default.number.isRequired,
  extendDropDownStyle: _propTypes2.default.string,
  onSearch: _propTypes2.default.func,
  isHorizontallySorted: _propTypes2.default.bool,
  isRequired: _propTypes2.default.bool,
  extendDropDownList: _propTypes2.default.array,
  extendDropDownListItem: _propTypes2.default.string,
  onClickIconAction: _propTypes2.default.func,
  componentName: _propTypes2.default.string.isRequired,
  isDisabled: _propTypes2.default.bool,
  isLoading: _propTypes2.default.bool,
  language: _propTypes2.default.string,
  isValid: _propTypes2.default.bool,
  onResetSearch: _propTypes2.default.func
} : {};
exports.default = DropDown;
module.exports = exports['default'];